import { ContainedBtn } from '@components/Buttons';
import { MenuItemData } from '@components/Navigation/types';
import { navigateAppStore, Routes } from '@navigation';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import ChevronRightIcon from './assets/chevronRight.inline.svg';

interface Props extends StyleProps {
  items: MenuItemData[];
  onMenuItemClick?: (itm: MenuItemData) => void;
  onLinkClick?: () => void;
}

export const MobileTreeViewMenu: FC<Props> = ({ className, items, onMenuItemClick, onLinkClick }) => {
  const handleGetAppClick = () => {
    navigateAppStore(() => {
      const element = document.getElementById('app-download-footer');
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.href = Routes.app.url;
    });
    onLinkClick && onLinkClick();
  };

  const renderBtnContent = (itm: MenuItemData) => (
    <>
      <span className="flex flex-col justify-start items-start">
        <span className="block font-sharpsans leading-normal font-bold text-ocean-blue uppercase text-xl">{itm.title}</span>
        {!!itm.subtitle && (
          <span className="block text-base font-raleway leading-normal font-medium text-ocean-blue">{itm.subtitle}</span>
        )}
      </span>
      {itm.items && <ChevronRightIcon className="stroke-ocean-blue" />}
    </>
  );

  const btnClassName = 'flex flex-row px-8 py-4 sm:py-6 justify-between items-start';

  return (
    <>
      <div className={mc('flex flex-col pt-6 sm:pt-12 pb-28', className)}>
        {items.map(itm =>
          itm.items ? (
            <button key={itm.title} className={btnClassName} onClick={() => onMenuItemClick && onMenuItemClick(itm)}>
              {renderBtnContent(itm)}
            </button>
          ) : (
            <a key={itm.title} href={itm.url || '#'} className={btnClassName} onClick={onLinkClick}>
              {renderBtnContent(itm)}
            </a>
          ),
        )}
      </div>
      <div className="px-8 pb-8 pt-4 fixed left-0 right-0 bottom-0 bg-white">
        <ContainedBtn className="w-full text-center" color="orange" onClick={handleGetAppClick}>
          {'Get The App'}
        </ContainedBtn>
      </div>
    </>
  );
};

export type MobileTreeViewMenuProps = Props;
export default MobileTreeViewMenu;
